import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrackingGoogleDetail,
  getTrackingFacebookDetail,
} from "../redux/centerData/CenterDataSlice";

const COOKIE_EXPIRATION_DAYS = 30;

const CookiePolicy = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth || {});
  const todos = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getTrackingGoogleDetail());
        await dispatch(getTrackingFacebookDetail());
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching cookie policy:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const tracking = todos.CenterDataSlice.TrackingGoogle?.results || [];
  const trackingIds = tracking.map((item) => item.tracking_id);

  const app = todos.CenterDataSlice.TrackingFacebook?.results || [];
  const appIds = app.map((item) => item.tracking_id);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (consent) {
      const { consent: isAccepted, date } = JSON.parse(consent);
      const expirationDate = new Date(date);
      expirationDate.setDate(expirationDate.getDate() + COOKIE_EXPIRATION_DAYS);

      if (isAccepted && new Date() < expirationDate) {
        setIsVisible(false);
        enableTracking(trackingIds, appIds);
      } else {
        setIsVisible(true);
      }
    } else {
      setIsVisible(true);
    }
  }, [trackingIds, appIds]);

  const handleAccept = () => {
    const consentData = {
      consent: true,
      date: new Date().toISOString(),
    };

    localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    setIsVisible(false);
    enableTracking(trackingIds, appIds);
  };

  return isVisible ? (
    <div className="cookie-banner">
      <div className="cookie-text">
        <p>
          <strong>{t("We value your privacy.")}</strong>
        </p>
        <p>
          {t(
            "We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking “Accept All”, you consent to our use of cookies."
          )}
          &nbsp;
          <a href="/cookiePolicy">{t("Cookie Policy")}</a>
        </p>
      </div>
      <button className="accept" onClick={handleAccept}>
        {t("Accept")}
      </button>
    </div>
  ) : null;
};

const enableTracking = (trackingIds, appIds) => {
  if (trackingIds?.length) {
    trackingIds.forEach((trackingId) => {
      const gaScript = document.createElement("script");
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      gaScript.async = true;

      gaScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }

        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", trackingId);
      };

      document.head.appendChild(gaScript);
    });
  }

  if (appIds?.length) {
    appIds.forEach((appId) => {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      window.fbq("init", appId);
      window.fbq("track", "PageView");
    });
  }
};

export default CookiePolicy;
